// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-cf51e862]:export {\n  menuBg: #E25527;\n  menuText: #ffffff;\n  menuActiveText: #E25527;\n  menuActiveBg: #ffffff;\n}\n\n/* Mixins */\n.message-title[data-v-cf51e862] {\n  font-size: 16px;\n  color: #333;\n  font-weight: bold;\n  padding-right: 8px;\n}", ""]);
// Exports
module.exports = exports;
